import { createFileRoute, notFound } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/ServiceDetail";
import { content } from "@/lib/content";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, serviceSchema, breadcrumbList, faqPage } from "@/lib/schema";
import { SERVICE_TYPE, areaServedFor, titleWithLabel, META_DESCRIPTION } from "@/lib/services-meta";

export const Route = createFileRoute("/ar/services/$slug")({
  beforeLoad: ({ params }) => {
    if (!content.services.items.find((i) => i.slug === params.slug)) throw notFound();
  },
  head: ({ params }) => {
    const item = content.services.items.find((i) => i.slug === params.slug);
    if (!item) return {};
    const title = item
      ? `${titleWithLabel(item.label, item.title.ar, "ar")} — عراق سيرت`
      : "خدمة آيزو — عراق سيرت";
    const description = item
      ? (META_DESCRIPTION[item.slug]?.ar ?? item.heroSubtitle.ar)
      : "خدمات شهادات الآيزو من عراق سيرت.";
    const url = absolute(`/ar/services/${params.slug}`);

    const scripts = item
      ? [
          {
            type: "application/ld+json",
            children: JSON.stringify(
              graph(
                serviceSchema({
                  path: `/ar/services/${item.slug}`,
                  name: titleWithLabel(item.label, item.title.ar, "ar"),
                  serviceType: SERVICE_TYPE[item.slug] ?? item.title.en,
                  description,
                  areaServed: areaServedFor(item.slug),
                }),
                breadcrumbList([
                  { name: "الرئيسية", path: "/ar" },
                  { name: "خدماتنا", path: "/ar/services" },
                  {
                    name:
                      item.slug === "ministry-of-oil-vendor-registration"
                        ? "وزارة النفط العراقية"
                        : item.slug === "oil-gas-registration"
                          ? "النفط والغاز"
                          : item.label,
                    path: `/ar/services/${item.slug}`,
                  },
                ]),
                ...(content.faq.services[item.slug]?.length
                  ? [
                      faqPage(
                        `/ar/services/${item.slug}`,
                        content.faq.services[item.slug].map((f) => ({
                          q: f.q.ar,
                          a: f.a.ar,
                        })),
                      ),
                    ]
                  : []),
              ),
            ),
          },
        ]
      : [];

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:locale", content: "ar_IQ" },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks(`/services/${params.slug}`)],
      scripts,
    };
  },
  component: ServiceDetailPageAr,
});

function ServiceDetailPageAr() {
  const { slug } = Route.useParams();
  const item = content.services.items.find((i) => i.slug === slug);

  if (!item) throw notFound();

  return <ServiceDetail item={item} />;
}
